/**
 * Currency affix resolution — the one place the configured symbol is read.
 *
 * Guards the "$575.00$" double-symbol display: `finance.currencyPrefix`
 * defaults to '$', and an admin who wants the French-Canadian trailing symbol
 * typically fills in `finance.currencyPostfix` ('$') WITHOUT clearing the
 * prefix — so the same symbol lands on both sides of every amount. When the
 * postfix merely repeats the prefix symbol we keep the prefix only, so a
 * mis-set config degrades to the conventional "$575.00" instead of a visibly
 * broken amount. A genuinely different postfix (" CAD") is preserved, as is a
 * postfix-only config (prefix cleared).
 *
 * Every money formatter — SystemConfigContext's formatCurrency/formatBalance,
 * the analytics compact formatters, Dashboard's chart axis — must go through
 * here rather than reading the two config fields directly.
 */
export const resolveCurrencyAffixes = (config) => {
  const prefix = config?.finance?.currencyPrefix ?? '$';
  const rawPostfix = config?.finance?.currencyPostfix ?? '';
  const sameSymbol =
    String(prefix).trim() !== ''
    && String(rawPostfix).trim() !== ''
    && String(prefix).trim() === String(rawPostfix).trim();
  return { prefix, postfix: sameSymbol ? '' : rawPostfix };
};

export default resolveCurrencyAffixes;
